import React, { createContext, useState, useContext } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

// Translations dictionary
export const translations = {
    en: {
        // Sidebar menu
        home: 'Dashboard',
        learningCorner: 'Learning Corner',
        fullMockTests: 'Journey / Mock Tests',
        skillPractice: 'Skill Practice',
        skillMap: 'Skill Map',
        recentActivity: 'History & Review',
        library: 'Library',
        logout: 'Logout',
        // Dashboard cards
        choosePath: 'Learning Path',
        learningCornerTitle: 'Learning Corner',
        learningCornerDesc: 'Strengthen your Flyers vocabulary and grammar with focused exercises, topic-based word lists, and interactive drills.',
        learningCornerCta: 'Study Now',
        skillPracticeTitle: 'Skill Practice',
        skillPracticeDesc: 'Sharpen your Listening, Reading & Writing, and Speaking skills with targeted practice sets aligned to the Flyers exam format.',
        skillPracticeCta: 'Start Now',
        fullMockTestTitle: 'Full Mock Test',
        fullMockTestDesc: 'Take a full-length mock exam that mirrors the real Flyers test — timed, structured, and scored just like the actual exam.',
        fullMockTestCta: 'Take Test',
        // Language names
        langLabel: 'English',
        langFlag: '🇬🇧',
    },
    vi: {
        // Sidebar menu
        home: 'Trang Chủ',
        learningCorner: 'Góc Học Tập',
        fullMockTests: 'Lộ Trình / Thi Thử',
        skillPractice: 'Luyện Kỹ Năng',
        skillMap: 'Bản Đồ Năng Lực',
        recentActivity: 'Lịch Sử Làm Bài',
        library: 'Thư Viện',
        logout: 'Đăng Xuất',
        // Dashboard cards
        choosePath: 'Lộ trình học',
        learningCornerTitle: 'Góc Học Tập',
        learningCornerDesc: 'Xây dựng vốn từ vựng và ngữ pháp Flyers qua các bài tập chủ đề, danh sách từ theo chủ đề và luyện tập tương tác.',
        learningCornerCta: 'Học ngay',
        skillPracticeTitle: 'Luyện Kỹ Năng',
        skillPracticeDesc: 'Nâng cao kỹ năng Nghe, Đọc-Viết và Nói với các bộ bài tập chuyên sâu, bám sát cấu trúc đề thi Flyers thật.',
        skillPracticeCta: 'Bắt đầu',
        fullMockTestTitle: 'Đề Thi Thử',
        fullMockTestDesc: 'Làm bài thi thử đầy đủ đúng định dạng Flyers — có tính giờ, cấu trúc chuẩn và chấm điểm như kỳ thi thật.',
        fullMockTestCta: 'Thi ngay',
        // Language names
        langLabel: 'Tiếng Việt',
        langFlag: '🇻🇳',
    },
};

export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState(
        () => localStorage.getItem('appLang') || 'vi'
    );

    const toggleLang = () => {
        const next = lang === 'vi' ? 'en' : 'vi';
        setLang(next);
        localStorage.setItem('appLang', next);
    };

    const t = (key) => translations[lang][key] ?? key;

    return (
        <LanguageContext.Provider value={{ lang, toggleLang, t }}>
            {children}
        </LanguageContext.Provider>
    );
};
